<template>
	<el-form ref="dynamicValidateForm"  label-position="top" id="form" >
		<el-row type="flex">
			<el-col :span="11">
				<app-modal-add-field :formModel="formModel" :formName="formName" :formEmail="validEmail"></app-modal-add-field>
			</el-col>
			<el-col :span="1"></el-col>
			<el-col :span="11">
				<el-card>
					<el-row>
						<el-col :span="24">
							<h2>{{ Tipo }}  {{formName}}</h2>
						</el-col>
						<el-col :span="10">
							<el-form-item >
								<el-input v-model="formName" type="text" placeholder:="Nombre del formulario"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="2"></el-col>
						<el-col :span="13">
							<el-form-item>
								<!-- Formulario o encuesta -->
								<el-radio-group v-model="formModel">
									<el-radio class="mx-2" border label="1" >Formulario</el-radio>
									<el-radio border label="2">Encuesta</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<!-- Formulario: email de envío -->
							<el-form-item v-if="formModel == 1" class="mt-2">
								<el-input
									v-model="formEmail"
									type="email"
									placeholder="Email de envío">
									<i slot="prefix" class="fa fa-at"></i>
								</el-input>
							</el-form-item>
						</el-col>
						<draggable v-model="tipeForm" >
							<transition-group name="list-complete">
								<el-col v-if="tipeForm" v-for="(f, i) in tipeForm" :key="i+1" :span="24" class="drag">
									<i class="fa fa-times-circle drag-close" @click="removeItem(i)"></i>
									<app-item-form :f="f"></app-item-form>
								</el-col>
							</transition-group>
						</draggable>

					</el-row>
				</el-card>
			</el-col>
		</el-row>
	</el-form>
</template>
<script>
	import ApiService from "@/common/api.service"
	import itemForm from '@/components/Dashboard/pages/templates/itemsForm'
	import modalAddFiel from '@/components/Dashboard/pages/templates/addFieldForm'
	import draggable from 'vuedraggable'

	export default {
		name: 'formulario',
		props: ["content"],
		components: {
			"app-item-form": itemForm,
			"app-modal-add-field": modalAddFiel,
			draggable
		},
		created () {
			this.$root.$on('addField', (a)=> this.addNewField(a) )
			this.$root.$on("saveContent", (id) => {
				this.id = id
				this.section_id = id
				this.submitForm()
			})
			if (this.content) {
				this.getContent();
			}
		},
		watch: {
			$route(to) {
				if (this.content) {
					this.getContent();
				}
			}
		},
		data() {
			return {
				id: false,
				formName: null,
				formModel: false,
				formEmail: null,
				dynamicForm: [],
				options: false,
				showModalAdd: false,
				section_id: false,
				btn: 'Crear formulario'
			}
		},
		methods: {
			async getContent() {
				const a = await ApiService.post("dashboard/table", {
					table: "formulario",
					token: localStorage.getItem("token"),
					project_id: localStorage.getItem("table"),
					id: this.$route.params.content_id
				})
				if(a.status === 200){
					this.formName = a.data.title
					this.formModel = a.data.model
					this.formEmail = a.data.email
					this.dynamicForm = JSON.parse(a.data.form)
				}
			},
			async submitForm() {
				if(!this.formName){
					this.$root.$emit('mensaje', 'error', 'El nombre del formulario es obligatorio')
					return false
				}
				let form = {
					model: this.formModel,
					email: this.formEmail,
					title: this.formName,
					form: JSON.stringify(this.tipeForm)
				}

				this.content != 0 ? await this.update(form) : await this.insert(form);
			},
			async insert(form) {
				const a = await ApiService.post("dashboard/editform", {
					table: "formulario",
					token: localStorage.getItem("token"),
					project_id: localStorage.getItem("table"),
					form: form
				})
				if(a.status === 200){
					this.id = a.data
					this.$root.$emit('mensaje', 'success', 'Formulario creado')

					const b = await ApiService.post("dashboard/editform", {
						table: "contents",
						token: localStorage.getItem("token"),
						project_id: localStorage.getItem("table"),
						form: {
							template_id: 5,
							registro_id: a.data
						}
					})
					if(b.status === 200){
						ApiService.post("dashboard/editform", {
							table: "sections_contents",
							token: localStorage.getItem("token"),
							project_id: localStorage.getItem("table"),
							form: {
								section_id: this.section_id,
								content_id: b.data
							}
						})
					}
				}

			},
			async update(form) {
				const a = await ApiService.post("dashboard/editform", {
					table: "formulario",
					token: localStorage.getItem("token"),
					project_id: localStorage.getItem("table"),
					form: form,
					id: this.$route.params.content_id
				})

				if(a.status === 200) this.$root.$emit('mensaje', 'success', 'Formulario actualizado')
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			removeDomain() {
				this.dynamicForm = []
			},
			async getGroupOption(id) {
				const a = await ApiService.post("dashboard/listgroupoptions", {
					table: "formulario_opciones_grupo",
					token: localStorage.getItem("token"),
                    project_id: localStorage.getItem("table"),
                    grupo_id: id
				})
				if(a.status === 200){
                    if(a.data !== "Algo ha fallado"){
                       this.options = a.data.map ( e => {
						   return {
							   id: e.id,
							   key: e.value,
							   label: e.item,
							   value: e.value
						   }
					   })
					}
				}
            },
			addNewField(item) {
				this.showModalAdd = !this.showModalAdd
				let options;
				item.option ? this.getGroupOption(item.option) : this.options = null;
				setTimeout(() => {
					this.dynamicForm.push({
						type: item.tipe,
						field: item.field,
						label: item.label,
						options: this.options
					});
				}, 500);
			},
			removeItem(index){
				this.dynamicForm.splice(index, 1)
			}
		},
		computed: {
			validEmail() {
				return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(this.formEmail);
			},
			tipeForm() {
				let type = ['select', 'radio', 'checkbox']
				return this.dynamicForm.filter( e => {
					if(this.formModel == 2){
						return type.includes(e.type) ? e : false ;
					}else{
						return e
					}
				})
			},
			Tipo () {
				return this.formModel == 2 ? 'Encuesta' : 'Formulario';
			}
		}
	}
</script>

<style lang="scss">
	.drag {
		border: 1px solid #cddfd7;
		background: #f5f7fa;
		border-radius: 10px;
		padding: 10px 25px;
		margin-bottom: 5px;
		position: relative;
		&::before{
			content: "\F142";
			display: inline-block;
			font-family: 'FontAwesome';
			font-size: 25px;
			text-rendering: auto;
			position: absolute;
			top: 64%;
			left: 10px;
			transform: translate(0, -50%);
		}
		&-close{
			position: absolute;
			right: 0;
			color: red;
			font-size: 26px;
			cursor: pointer;
		}
	}
	.el-radio.is-bordered+.el-radio.is-bordered {
    	margin-left: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/pages/templates/formulario.vue